export default __webpack_public_path__ + "static/conc-back-0020358fdbdf5452a688033442140508.webp";